import { useEffect, useState } from "react";
import { Plus, Trash2, X } from "lucide-react";
import api from "@/api";
import { toast } from "sonner";
import AdminSettings from "./AdminSettings";

export default function AdminSeo() {
  const [redirects, setRedirects] = useState(null);
  const [adding, setAdding] = useState(false);
  const [f, setF] = useState({ from: "", to: "", type: 301 });
  const load = () => api.get("/admin/redirects").then(({ data }) => setRedirects(data));
  useEffect(() => { load(); }, []);
  const add = async (e) => {
    e.preventDefault();
    try { await api.post("/admin/redirects", f); toast.success("Redirect created"); setAdding(false); setF({ from: "", to: "", type: 301 }); load(); }
    catch (err) { toast.error(err.friendlyMessage); }
  };
  const del = async (id) => { await api.delete(`/admin/redirects/${id}`); load(); };
  return (
    <div data-testid="admin-seo">
      <AdminSettings section="seo" />
      <div className="max-w-3xl mt-10">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h2 className="font-serif text-2xl">301 Redirect Manager</h2>
            <p className="text-sm text-[#6E6D6A]">Essential for migrations — point old URLs to new ones.</p>
          </div>
          <button onClick={() => setAdding(true)} data-testid="redirect-create-btn" className="tq-btn-dark !py-2.5"><Plus size={14} /> Add Redirect</button>
        </div>
        {adding && (
          <form onSubmit={add} className="bg-white border border-[#D4AF37]/50 p-4 grid sm:grid-cols-[1fr_1fr_auto_auto] gap-3 mb-4" data-testid="redirect-form">
            <input required value={f.from} onChange={(e) => setF({ ...f, from: e.target.value })} placeholder="/old-url" data-testid="redirect-from" className="tq-input" />
            <input required value={f.to} onChange={(e) => setF({ ...f, to: e.target.value })} placeholder="/new-url" data-testid="redirect-to" className="tq-input" />
            <select value={f.type} onChange={(e) => setF({ ...f, type: Number(e.target.value) })} className="tq-input bg-white">
              <option value={301}>301 Permanent</option><option value={302}>302 Temporary</option>
            </select>
            <div className="flex gap-2">
              <button className="tq-btn-dark !py-2" data-testid="redirect-save">Add</button>
              <button type="button" onClick={() => setAdding(false)} className="tq-btn-outline !py-2" aria-label="Cancel"><X size={14} /></button>
            </div>
          </form>
        )}
        {!redirects ? <div className="h-24 bg-white animate-pulse" /> : redirects.length === 0 ? (
          <div className="bg-white border border-[#E5DEC9] p-8 text-center text-[#6E6D6A] text-sm">No redirects yet.</div>
        ) : (
          <div className="bg-white border border-[#E5DEC9] divide-y divide-[#F4EFE6]">
            {redirects.map((r) => (
              <div key={r.id} className="p-3 flex items-center gap-3 text-sm" data-testid={`redirect-row-${r.id}`}>
                <span className="font-mono text-xs">{r.from}</span>
                <span className="text-[#C5A059]">→</span>
                <span className="font-mono text-xs flex-1">{r.to}</span>
                <span className="text-[10px] font-bold bg-[#F4EFE6] px-2 py-0.5">{r.type}</span>
                <button onClick={() => del(r.id)} aria-label="Delete redirect" className="text-[#8B1E21]"><Trash2 size={14} /></button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
